import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout/DashboardLayout';
import WelcomeCard from '../../components/dashboard/WelcomeCard/WelcomeCard';
import RegulatoryCard from '../../components/dashboard/RegulatoryCard/RegulatoryCard';
import Card from '../../components/common/Card/Card';
import LoadingSpinner from '../../components/common/LoadingSpinner/LoadingSpinner';
import useApi from '../../hooks/useApi';
import dashboardService from '../../services/dashboardService';
import './DashboardPage.css';
import { useAuth } from '../../contexts/AuthContext';

const DashboardPage = () => {
    //const { data: stats, loading, error } = useApi(dashboardService.getStats);
    const { user, selectedTenant } = useAuth();

    const stats = {
        tasks: 0,
        deadlines: 0,
        documents: 0
    };
    const loading = false;
    const error = null;

    if (loading) {
        return (
            <DashboardLayout>
                <LoadingSpinner />
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout>
            <div className="dashboard-page">
                <WelcomeCard
                    userName={`${user?.user_vorname || ''} ${user?.user_name || ''}`.trim() || 'Benutzer'}
                    tenantName={selectedTenant?.name}
                />

                <div className="dashboard-grid">
                    <RegulatoryCard />

                    <Card title="Aufgaben" variant="success" className="dashboard-stat-card">
                        <div className="coming-soon-badge">Bald</div>
                        <div className="stat-value">{stats?.tasks || 0}</div>
                        <div className="stat-label">Offene Aufgaben</div>
                    </Card>


                    <Card title="Fristen" variant="warning">
                        <div className="coming-soon-badge">Bald</div>
                        <div className="stat-value">{stats?.deadlines || 0}</div>
                        <div className="stat-label">Diese Woche</div>
                    </Card>

                    <Card title="Dokumente" variant="default">
                        <div className="coming-soon-badge">Bald</div>
                        <div className="stat-value">{stats?.documents || 0}</div>
                        <div className="stat-label">Zur Prüfung</div>
                    </Card>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default DashboardPage;